import React from 'react';
import { motion } from 'framer-motion';

const TimestampSeparator = React.forwardRef(({ timestamp }, ref) => {
  return (
    <motion.div 
      ref={ref}
      className="flex items-center justify-center my-4"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1">
        <span className="text-xs text-white/70 font-medium">
          {timestamp}
        </span>
      </div>
    </motion.div>
  );
});

TimestampSeparator.displayName = 'TimestampSeparator';

export default TimestampSeparator;